class NoSessionAvailable extends Error {
}
export default NoSessionAvailable;
